export enum OptionTagEnum {
    SELECTABLE = 'selectable'
}
